import React, {useEffect, useState} from "react";
import { Navigate, Route, Routes, useSearchParams} from "react-router-dom";
import PublicMap from "./app/pages/publicMap/PublicMap";
import MainLayout from "./app/MainLayout";
import Workspaces from "./app/pages/workspace/Workspaces";
import NotFound from "./app/components/NotFound/NotFound";
import Projects from "./app/pages/projects/Projects";
import ProjectLayout from "./app/ProjectLayout";
import Dashboard from "./app/pages/dashboard/Dashboard";
import { setGuestShareDetails } from "./services/guestService";
import { Spin } from "antd";


const ShareRoutes = () => {
    const [initialized, setInitialized] = useState(false);
    const [searchParams] = useSearchParams();

    function setProjectHeaders () {
        if(searchParams.get('projectId') || searchParams.get('projectName')) {
            localStorage.setItem('currentProjectID', searchParams.get('projectId'))
            localStorage.setItem('projectRoundName', searchParams.get('projectName'))
        }
    }
    useEffect(() => {
        setGuestShareDetails();
        setProjectHeaders();
        setInitialized(true);
    },[])


    if(!initialized) {
        return (
            <Spin/>
        )
    }
    else {
        return (
            <Routes>
                <Route path="/" element={<Navigate replace to='/projects' />} />
                <Route path="/publicMap" element={<PublicMap />} />
                <Route
                    path="projects"
                    loader={setGuestShareDetails}
                    element={
                    <Projects
                        isGuestShare={true}
                        // notifications={notifications}
                        // setNotifications={setNotifications}
                        // unreadNotifications={unreadNotifications}
                        // setUnreadNotifications={setUnreadNotifications}
                    />
                    }
                />
                <Route
                    path="dashboard/*"
                    element={
                    <MainLayout
                        // notifications={notifications}
                        // setNotifications={setNotifications}
                        // unreadNotifications={unreadNotifications}
                        // setUnreadNotifications={setUnreadNotifications}
                    />
                    }
                >
                    <Route path="contracts" element={<Workspaces />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
                <Route
                    path="project/*"
                    loader={() => setProjectHeaders()}
                    element={
                    <ProjectLayout
                        // notifications={notifications}
                        // setNotifications={setNotifications}
                        // unreadNotifications={unreadNotifications}
                        // setUnreadNotifications={setUnreadNotifications}
                    />
                    }
                >
                    <Route
                    path="dashboard"
                    element={<Dashboard />}
                    />
                    <Route path="*" element={<NotFound />} />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        )
    }
}

export default ShareRoutes;